<form>
  <ng-container *transloco="let t; read: 'ime.system.role'">
    <mes-api-response-summary class="d-none" [response]="response"></mes-api-response-summary>
    <h5 class="card-title pb-1">{{t('General info')}}</h5>
    <div class="form-group row">
      <label for="Name" class="col-sm-4 col-form-label">{{t('Name')}}</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" id="Name" name="Name" [(ngModel)]="role.Name">
      </div>
    </div>
    <div class="form-group row">
      <label for="Comment" class="col-sm-4 col-form-label">{{t('Description')}}</label>
      <div class="col-sm-8">
        <textarea type="text" class="form-control" id="Comment" name="Comment" [(ngModel)]="role.Comment"></textarea>
      </div>
    </div>
    <div class="modal-body" *ngIf="(privileges$ | async) as privileges; else loading">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{t('Privileges')}}</h5>
          <ng-select class="select-sm form-control" [items]="privileges" labelForId="children" name="children" [(ngModel)]="role.Privileges"
                     bindLabel="Name" [virtualScroll]="true" [multiple]="true"
                     bindValue="Id">
          </ng-select>
        </div>
      </div>
    </div>
    <ng-template #loading>{{t('Loading')}}...</ng-template>
  </ng-container>
</form>
